import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteMediaAsset } from '~/services/MediaService';

import { mediaAssetQueryKeys, mediaPackageQueryKeys } from './mediaQueryKeys';

/**
 * Removes a media asset.
 *
 * Packages are refreshed too: a removed asset is taken out of every package bundling it, so their
 * totals change with it.
 */
export function useDeleteMediaAsset() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (assetId: string) => deleteMediaAsset(assetId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: mediaAssetQueryKeys.all });
      await queryClient.invalidateQueries({ queryKey: mediaPackageQueryKeys.all });
    },
  });
}
